import React from "react";
import Modal from "react-bootstrap/Modal";
import { Campaign, Network } from "../../types";
import CampaignDetails from "./CampaignDetails";

interface CampaignDetailsModalProps {
    show: boolean;
    onHide: () => void;
    network: Network;
    campaign: Campaign;

}

const CampaignDetailsModal: React.FC<CampaignDetailsModalProps> = ({
    show,
    onHide,
    network,
    campaign
}) => {
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Network Details: {network.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <CampaignDetails
                    campaign={campaign}
                    network={network}
                />
            </Modal.Body>
        </Modal>
    );
};

export default CampaignDetailsModal;
